import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './order.routes';
import addHtml from './modal/add.html';

export class OrderController {
    $http;
    socket;
    awesomeThings = [];
    orders = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        // $scope.$on('$destroy', function() {
        //   socket.unsyncUpdates('search');
        // });
    }

    $onInit() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/orders/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {


                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.orders = response.data.data;
                        this.socket.syncUpdates('order', this.orders);
                    }

                });
        } else {
            this.$location.path('main')
        }
    }

    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }
        const payload = angular.copy(this.filters);



        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };
        if (this.$cookies.get('token')) {

            this.$http.get('/api/orders/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.orders = response.data.data;

                        this.socket.syncUpdates('order', this.orders);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    // addThing() {
    //   if(this.newThing) {
    //     this.$http.post('/api/things', {
    //       name: this.newThing
    //     });
    //     this.newThing = '';
    //   }
    // }

    deleteOrder(order, index) {
        this.$http.delete(`/api/orders/${order.order_id}`).then(response => {
            if (response.status === 204) {
                this.orders.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }
}

export default angular.module('tttApp.order', [uiRouter])
    .config(routing)
    .component('order', {
        template: require('./order.html'),
        controller: OrderController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/order/order.component.js